Ext.ns('mx.app.widget');

mx.app.widget.UsersEditForm = Ext.extend(mx.comp.FormPanel, {
    name: 'userseditform_container',
    layout: 'column',
    border: false,
    autoHeight: true,
    labels: {},

    initComponent: function() {
        mx.app.widget.UsersEditForm.superclass.initComponent.apply(this, arguments);

        var userRolesPanel;

        var userRolesItems = [];
        for (var p in mx.userRoleControl) {
            if (typeof mx.userRoleControl[p] == 'function') {
                userRolesItems.push(
                    new mx.userRoleControl[p]({
                        userId: this.params['userId'] || -1,
                    })
                );
            }
        }
        userRolesItems.sort(function(a, b) {
            if (a.position > b.position) return 1;
            if (a.position < b.position) return -1;
            return 0;
        });

        var userRolesPanels = [];
        userRolesItems.forEach(function(panel) {
            userRolesPanels.push(
                new Ext.Panel({
                    items: panel,
                    border: false,
                    layout: 'anchor',
                    readOnly: panel.readOnly,
                    defaults: {
                        anchor: '100%',
                    },
                    listeners: {
                        afterlayout: {
                            fn: function() {
                                if (this.readOnly) {
                                    this.el.maskCustom();
                                    Ext.fly(this.el)
                                        .select('input,select,a,button')
                                        .each(function(el) {
                                            if (!el.dom.disabled) {
                                                el.dom.disabled = true;
                                            }
                                        });
                                }
                            },
                        },
                    },
                })
            );
        });

        this.add(
            new mx.app.widget.UsersInfoForm({
                columnWidth: 0.5,
                showYourPassword: false,
                isNew: this.isNew,
            }),
            (userRolesPanel = new Ext.Panel({
                columnWidth: 0.5,
                border: false,
                header: false,
                layout: 'form',
                defaults: {
                    anchor: '100%',
                },
                bodyStyle: 'padding-left: 5px;',
                items: userRolesPanels,
            })),
            {
                xtype: 'hidden',
                name: 'roles',
                setValue: function(value) {
                    var roles = value.data;
                    for (var i = 0; i < userRolesItems.length; i++) {
                        userRolesItems[i].setValue(roles[userRolesItems[i].getName()]);
                    }
                },
                getValue: function() {
                    var userRolesValues = {};
                    for (var i = 0; i < userRolesItems.length; i++) {
                        userRolesValues[userRolesItems[i].getName()] = userRolesItems[i].getValue();
                    }
                    return new mx.data.UserRoles(userRolesValues);
                },
                validate: function() {
                    var res = false;
                    for (var i = 0; i < userRolesItems.length; i++) {
                        res = res || userRolesItems[i].getValue();
                    }
                    return res;
                },
                isDirty: function() {
                    var res = false;
                    for (var i = 0; i < userRolesItems.length; i++) {
                        res =
                            res ||
                            Ext.encode(userRolesItems[i].getValue()) != Ext.encode(userRolesItems[i].originalValue);
                    }
                    return res;
                },
            },
            {
                xtype: 'hidden',
                name: 'parameters',
                setValue: function(v) {
                    userRolesItems.forEach(function(userRole) {
                        if (userRole['applyParameters']) {
                            userRole.applyParameters.call(userRole, v);
                        }
                    });
                },
                getValue: function() {
                    var parameters = {};
                    userRolesItems.forEach(function(userRole) {
                        if (userRole['parameters']) {
                            Ext.apply(parameters, userRole.parameters);
                        }
                    });
                    return new mx.data.UserParameters(parameters);
                },
            }
        );
    },
});
